import side from '../../api/side'

export default {
    namespaced: true,
    state: {
        items: [],

        isLoaded: false,
    },
    mutations: {
        setItems: function(state, items) {
            state.items = items
            state.isLoaded = true
        },
    },

    getters: {
        state: state => state,

        isLoaded: state => {
            return state.isLoaded
        },

        isFound: state => {
            return state.isLoaded && state.items.length > 0
        },

        isNoresult: state => {
            return !state.isLoaded || state.items.length == 0
        },

        items: state => {
            return state.isLoaded ? state.items : null
        },

        employ: state => {
            return state.isLoaded && state.items.employ_types !== void 0 && state.items.employ_types.length > 0 ? 
                    state.items.employ_types : null
        },

        facility: state => {
            return state.isLoaded && state.items.facility_types !== void 0 && state.items.facility_types.length > 0 ? 
                    state.items.facility_types : null
        },

        job: state => {
            return state.isLoaded && state.items.job_types !== void 0 && state.items.job_types.length > 0 ? 
                    state.items.job_types : null
        },

        option: state => {
            return state.isLoaded && state.items.options !== void 0 && state.items.options.length > 0 ? 
                    state.items.options : null
        },
    },

    actions: {
        getAreaLink: function({commit, getters}, area) { //area: tokyo, tokyo/chuo etc
            if (!area) return
            side.getItems(area, res => {
                commit('setItems', res.data)
            })
        },
    }
}


